import { t } from 'i18next'
import { Item } from '../../../../../store/types'
import Carousel from '../../schedule/carousel/CustomCarousel'

const translationBase = 'components.infoSidebar.worklog.carousel.vacation'

const WorklogCarousel = () => {
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.summary.subtitle`),
      description: t(`${translationBase}.summary.description`),
      key: 'carousel-worklog-info-vacation-1',
    },
    {
      subtitle: t(`${translationBase}.paidVacation.subtitle`),
      description: t(`${translationBase}.paidVacation.description`),
      key: 'carousel-worklog-info-vacation-1',
    },
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default WorklogCarousel
